<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <base-nested-spinner
          :status="$data.$_nestedSpinnerMixin_status"
          @reload="fetchData">
          <base-card
            title="Browse"
            icon="table_chart"
          >
            <v-flex xs-12>
              <BaseDataTables
                :options="options"
                class="table-bordered table-striped"
              >
                <thead>
                <tr>
                  <th>Biomarker categories</th>
                  <th>Full Name</th>
                  <th>Gene Symbol</th>
                  <th>Cancer</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="entity in data"
                  :key="entity.id"
                >
                  <td>{{entity.categories}}</td>
                  <td>
                    <router-link
                      v-if="entity.shouldLink === 1"
                      :to="{
                        name: 'rna',
                        params: {
                          rna: entity.gene,
                          rnaType: entity.rnaType,
                          tumor: entity.cancer
                        }
                      }">
                      {{entity.biomarker}}
                    </router-link>
                    <template v-else>
                      {{entity.biomarker}}
                    </template>
                  </td>
                  <td>{{entity.gene}}</td>
                  <td>{{entity.cancer}}</td>
                </tr>
                </tbody>
              </BaseDataTables>
            </v-flex>
          </base-card>
        </base-nested-spinner>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import nestedSpinnerMixin from '@/mixins/nestedSpinner';
import getBiomarkersInfo from '@/api/biomarkers';

export default {
  mixins: [nestedSpinnerMixin],
  data() {
    return {
      data: [],
      options: {
        pageLength: 50,
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const apiFn = () => getBiomarkersInfo();
      const resolve = (data) => {
        this.data = data.map(entity => ({
          categories: entity.categories,
          biomarker: entity.biomarker,
          gene: entity.gene,
          rnaType: entity.rna_type,
          cancer: entity.cancer,
          shouldLink: entity.link,
        }));
      };
      this.$_nestedSpinnerMixin_fetchData(apiFn, resolve);
    },
  },
};
</script>

<style scoped>

</style>
